import { callApiWithAuthorization } from "./CallApi";

export const POSTMARK_TEMPLATE_KEYS = {
    INVITE_TENANT_OWNER_TO_APP: "inviteTenantOwnerToAppKey",
    INVITE_USER: "inviteUserKey",
    ACTIVATE_USER: "activateUserKey",
    CLONE_FAILED: "cloneFailedKey",
};

export const sendEmailWithPostMark = async (email, templateKey, properties) => {
    await callApiWithAuthorization("/api/v0/sendEmailUsingPostmark", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            email: email,
            templateKey: templateKey,
            templateProperties: properties
        })
    });
};

export const sendUserAccountVerificationEmail = async (userId, loggedInUser, appUrl = null) => {
    let link = process.env.REACT_APP_DESIGNER_URL + "/_VerifyAccount/" + userId + "/" + loggedInUser.localAccountId
    if (appUrl) {
        link += "?appUrl=" + encodeURIComponent(appUrl);
    }
    let properties = {
        product_url: process.env.REACT_APP_PRODUCT_URL,
        product_name: process.env.REACT_APP_PRODUCT_NAME,
        user_name: loggedInUser.name || loggedInUser.username,
        url: link,
        company_name: process.env.REACT_APP_COMPANY_NAME,
        company_address: process.env.REACT_APP_COMPANY_ADDRESS,
        subject: 'Complete your Codeless ONE sign up',
    }
    console.log("properties", properties);
    await sendEmailWithPostMark(loggedInUser.username, POSTMARK_TEMPLATE_KEYS.ACTIVATE_USER, properties);
}
